// load Fancybox instances
$(window).on('load', function () {
    if ($('.fancy-gallery').length > 0) {
        loadFancybox();
    }
});


function loadFancybox() {
    // default gallery fancybox
    $(".fancy-gallery").fancybox({
        buttons: [
            'close'
        ],
        animationEffect: "fade",
        animationDuration: 300,
        selector: '[data-fancybox="mixed"]',
        thumbs: false
    });

    // fancybox wrapper
    // todo: obsolete?
    $(".fancy-content-wrapper").fancybox({
        baseClass: "fancybox-content-wrapper",
        clickOutside: false,
        clickSlide: false,
        selector: '[data-fancybox="mixed-content"]',
        thumbs: false,
        touch: false,
        buttons: [
            'close'
        ],
        beforeLoad: function () {
            $('html').addClass("fancybox-locked");
        },
        afterClose: function () {
            $('html').removeClass("fancybox-locked");
        }
    });
}

